module.exports = __webpack_public_path__ + "img/product.2cf26854.png";